import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const RefreshIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m19.625 14.61-2.215-.77-.098.285a5.63 5.63 0 0 1-2.21 2.848 5.95 5.95 0 0 1-3.551.98h-.002a5.906 5.906 0 0 1-3.441-1.303 5.627 5.627 0 0 1-1.924-3.032 5.533 5.533 0 0 1 .34-3.544A5.697 5.697 0 0 1 9.003 7.43l.001-.001c1.098-.6 2.39-.84 3.635-.665h.002a5.898 5.898 0 0 1 2.356.851l-1.185.947c-.83.663-.558 1.986.465 2.269l4.256 1.174a1.3 1.3 0 0 0 1.646-1.23l.084-4.641c.02-1.1-1.252-1.727-2.112-1.04l-1.244.995a8.225 8.225 0 0 0-3.953-1.658 8.27 8.27 0 0 0-5.071.928 8.035 8.035 0 0 0-3.485 3.741 7.861 7.861 0 0 0-.483 5.058 7.978 7.978 0 0 0 2.73 4.309 8.265 8.265 0 0 0 5.177 1.833h.005c1.628 0 3.248-.482 4.569-1.37a8 8 0 0 0 3.132-4.035l.098-.283Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M11.468 19.99c.116.01.242.01.358.01 1.571 0 3.132-.466 4.402-1.32a7.7 7.7 0 0 0 3.016-3.884l-1.649-.573a5.931 5.931 0 0 1-2.327 3 6.25 6.25 0 0 1-3.732 1.03 6.205 6.205 0 0 1-3.617-1.37 5.926 5.926 0 0 1-2.027-3.194 5.833 5.833 0 0 1 .36-3.738 5.997 5.997 0 0 1 2.607-2.786 6.212 6.212 0 0 1 3.82-.7c1.024.138 2 .53 2.822 1.13l-1.503 1.2a1 1 0 0 0 .358 1.746l4.256 1.174a1 1 0 0 0 1.266-.946l.084-4.642a1 1 0 0 0-1.625-.799l-1.432 1.145a7.921 7.921 0 0 0-3.993-1.745 7.97 7.97 0 0 0-4.886.893A7.735 7.735 0 0 0 4.67 9.223a7.561 7.561 0 0 0-.466 4.864 7.677 7.677 0 0 0 2.628 4.146 7.964 7.964 0 0 0 4.635 1.757Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `RefreshIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { RefreshIcon };
//# sourceMappingURL=RefreshIcon.mjs.map
